import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "left"
};
const _hoisted_2 = {
  key: 0,
  class: "non-returnable-check-box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "text"
};
const _hoisted_5 = {
  key: 1,
  class: "total text-right"
};
const _hoisted_6 = {
  class: "text"
};
const _hoisted_7 = {
  class: "price-symbol"
};
const _hoisted_8 = {
  class: "price-nums"
};
const _hoisted_9 = {
  class: "price-symbol"
};
const _hoisted_10 = {
  class: "row"
};
const _hoisted_11 = {
  key: 0,
  class: "activity"
};
const _hoisted_12 = {
  class: "activity-text"
};
const _hoisted_13 = {
  class: "price"
};
const _hoisted_14 = {
  class: "activity-text"
};
const _hoisted_15 = {
  class: "price"
};
const _hoisted_16 = {
  key: 1,
  class: "total"
};
const _hoisted_17 = {
  class: "text"
};
const _hoisted_18 = {
  class: "price-symbol"
};
const _hoisted_19 = {
  class: "price-nums"
};
const _hoisted_20 = {
  class: "price-symbol"
};
const _hoisted_21 = {
  class: "right"
};
import { ref, computed } from 'vue';
import ShoppingAuthorizationPopup from './ShoppingAuthorizationPopup.vue';
import { showToast } from 'vant';
import { useStore } from 'vuex';
import { getCustomerConsent } from '@/models/api/orderConfirmApi';
import { priceSplice } from '@/utils/common';
import { useLess } from '@/models/hooks';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
export default {
  __name: 'BuyBox',
  props: {
    price: {
      type: Object,
      default: () => {
        return {
          originalShippingFee: 0,
          shippingFee: 0,
          importFee: 0,
          total: 0,
          discount: 0,
          promotionList: []
        };
      }
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    nums: {
      type: Number,
      default: 0
    },
    asinsList: {
      type: Array,
      default: () => []
    },
    nonReturnableTag: {
      type: Boolean
    },
    isPayButtonDisabled: {
      type: Boolean,
      default: () => true
    }
  },
  emits: ['pay', 'checkPay'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/spc/orderConfirm/components/BuyBox.less');
    const {
      t
    } = useI18n();
    const store = useStore();
    const CHECKED_SVG = `${constants.IMAGE_URL}assets/svg/checked.svg`;
    const UNCHECKOUT_SVG = `${constants.IMAGE_URL}assets/svg/notChecked.svg`;
    const distanceFromBottom = computed(() => {
      var _ref, _store$state$navigato;
      return (_ref = `${Number((_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.bottom) + 12}`) !== null && _ref !== void 0 ? _ref : 0;
    });
    const isChecked = ref(false);
    const checkImg = computed(() => {
      return isChecked.value ? CHECKED_SVG : UNCHECKOUT_SVG;
    });
    const isShowAuthorize = ref(false);
    const isAuthorize = ref(store.state.checkout.isAuthorize);
    const getIsAuth = async () => {
      try {
        const {
          data
        } = await getCustomerConsent({
          consentType: 'Order'
        });
        isAuthorize.value = data.customerConsents.Order.status === constants.CUSTOMER_CONSENT.TRUE;
      } catch (error) {
        console.log(error, 'getCustomerConsent---api---error');
      }
    };
    const handlePay = async () => {
      props.asinsList.forEach(asinid => {
        awsRumHandler.recordClickEvent({
          ...clickEvents.checkoutPage.payNowButton,
          asinid
        });
      });
      if (!props.isPayButtonDisabled) {
        emit('checkPay');
        return;
      }
      await getIsAuth();
      if (!isAuthorize.value) {
        isShowAuthorize.value = true;
        return;
      }
      if (props.nonReturnableTag && !isChecked.value) {
        showToast({
          message: t('modules.checkout.PLEASE_CHECK_THE_BOX_AT_THE_BOTTOM_OF_THE_PAGE'),
          overlayClass: 'a-overlay-white',
          className: 'a-toast'
        });
        return;
      }
      emit('pay');
    };
    const totalAmount = computed(() => {
      var _props$price, _props$price2, _props$price3, _props$price4;
      return (props === null || props === void 0 ? void 0 : (_props$price = props.price) === null || _props$price === void 0 ? void 0 : _props$price.total) + (props === null || props === void 0 ? void 0 : (_props$price2 = props.price) === null || _props$price2 === void 0 ? void 0 : _props$price2.shippingFee) + (props === null || props === void 0 ? void 0 : (_props$price3 = props.price) === null || _props$price3 === void 0 ? void 0 : _props$price3.importFee) - (props === null || props === void 0 ? void 0 : (_props$price4 = props.price) === null || _props$price4 === void 0 ? void 0 : _props$price4.discount);
    });
    const shippingDiscount = computed(() => {
      var _ref2, _props$price5, _props$price6, _discount$toFixed, _discount;
      let discount = 0;
      discount = (_ref2 = (props === null || props === void 0 ? void 0 : (_props$price5 = props.price) === null || _props$price5 === void 0 ? void 0 : _props$price5.originalShippingFee) - (props === null || props === void 0 ? void 0 : (_props$price6 = props.price) === null || _props$price6 === void 0 ? void 0 : _props$price6.shippingFee)) !== null && _ref2 !== void 0 ? _ref2 : 0;
      return (_discount$toFixed = (_discount = discount) === null || _discount === void 0 ? void 0 : _discount.toFixed(2)) !== null && _discount$toFixed !== void 0 ? _discount$toFixed : 0;
    });
    const handleChecked = () => {
      isChecked.value = !isChecked.value;
      if (isChecked.value) {
        awsRumHandler.recordClickEvent(clickEvents.checkoutPage.agreeToTermsAndConditionsButton);
      }
    };
    return (_ctx, _cache) => {
      var _props$price7;
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", {
        class: "order-foot-bar",
        style: _normalizeStyle({
          paddingBottom: distanceFromBottom.value
        })
      }, [_createElementVNode("div", _hoisted_1, [__props.nonReturnableTag ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
        class: "checked-box",
        onClick: handleChecked
      }, [_createElementVNode("img", {
        src: checkImg.value,
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('modules.checkout.CONFIRM_ORDER_CONTAINS_UNSUPPORTED_UNCONDITIONAL_RETURN')), 1)])])) : _createCommentVNode("", true), !__props.nonReturnableTag ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('modules.checkout.AMOUNT_TO')), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('common.currencyUnit')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(priceSplice)(totalAmount.value)[0]), 1), _createElementVNode("div", _hoisted_9, "." + _toDisplayString(_unref(priceSplice)(totalAmount.value)[1]), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [((_props$price7 = __props.price) === null || _props$price7 === void 0 ? void 0 : _props$price7.discount) > 0 || shippingDiscount.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [__props.price.discount > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('modules.checkout.PROMOTION_DISCOUNT')), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString(__props.price.discount.toFixed(2)), 1)], 64)) : _createCommentVNode("", true), shippingDiscount.value > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('modules.checkout.SAVED_ON_SHIPPING_FEES')), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString(shippingDiscount.value), 1)], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), __props.nonReturnableTag ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('modules.checkout.AMOUNT_TO')), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('common.currencyUnit')), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(priceSplice)(totalAmount.value)[0]), 1), _createElementVNode("div", _hoisted_20, "." + _toDisplayString(_unref(priceSplice)(totalAmount.value)[1]), 1)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_van_button, {
        color: "#EB1745",
        class: "confirm-btn",
        onClick: handlePay
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.PAY_NOW')) + " ", 1), _createElementVNode("span", null, "(" + _toDisplayString(__props.nums) + ")", 1)]),
        _: 1
      })]), _createVNode(ShoppingAuthorizationPopup, {
        show: isShowAuthorize.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => isShowAuthorize.value = $event)
      }, null, 8, ["show"])], 4);
    };
  }
};